import { savedTokens } from 'src/auth'
import {
  ErrorApi,
  ErrorNotLoggedIn,
  InputField,
  Preloader,
  SegmentedControl,
  Title,
} from 'src/components'
import { throwUnsupportedValue } from 'src/utils'
import { useListConnectUsers, useListCognitoUsers } from './queries'
import { savedUserFilter, savedUserQuery } from './storage'
import { UsersItem } from './Item'

type Props = {
  organization: string
  username: string
}

// TODO: save filter and query in localstorage

function Users(props: Props) {
  const connectUsers = useListConnectUsers({
    organization: props.organization,
    username: props.username,
  })
  const cognitoUsers = useListCognitoUsers({
    organization: props.organization,
    organizationforlist: props.organization,
    username: props.username,
  })

  const [filter, setFilter] = savedUserFilter.useState('ALL')
  const [query, setQuery] = savedUserQuery.useState('')

  if (
    connectUsers.isIdle ||
    connectUsers.isLoading ||
    cognitoUsers.isIdle ||
    cognitoUsers.isLoading
  ) {
    return <Preloader />
  }

  if (connectUsers.isError) {
    return (
      <ErrorApi message={connectUsers.error} onClick={connectUsers.refetch} />
    )
  }

  if (cognitoUsers.isError) {
    return (
      <ErrorApi message={cognitoUsers.error} onClick={cognitoUsers.refetch} />
    )
  }

  const users = connectUsers.data
    .map((connectUser) => ({
      ...connectUser,
      cognito: cognitoUsers.data.find(
        (cognitoUser) => cognitoUser.Username === connectUser.Username,
      ),
    }))
    .filter((item) => item.Username.includes(query))

  const filteredUsers = users.filter((item) => {
    switch (filter) {
      case 'ALL':
        return true
      case 'CONNECT':
        return !item.cognito
      case 'COGNITO':
        return !!item.cognito
      default:
        throwUnsupportedValue(filter)
        return null
    }
  })

  const filteredCognitoUser = users.filter((item) => item.cognito)

  return (
    <div className="grid grid-cols-2 gap-6 mb-12">
      <Title label="Users" />

      <div className="flex flex-row gap-6 col-span-full">
        <InputField
          label="Search users"
          value={query}
          setValue={setQuery}
          type="search"
          hideLabel
          placeholder="Search users"
          className="flex-1"
        />

        <SegmentedControl
          options={[
            { key: 'ALL', label: `All ${users.length}` },
            {
              key: 'CONNECT',
              label: `Disabled ${users.length - filteredCognitoUser.length}`,
            },
            { key: 'COGNITO', label: `Enabled ${filteredCognitoUser.length}` },
          ]}
          setActive={(item) => setFilter(item)}
          activeOption={filter}
        />
      </div>

      {filteredUsers.map((item) => (
        <UsersItem
          key={item.Username}
          organization={props.organization}
          username={props.username}
          {...item}
        />
      ))}
    </div>
  )
}

export default function ValidateUsers() {
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return <Users organization={tokens.organization} username={tokens.username} />
}
